<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="telephoneOperators"
      :items="telephoneOperators"
      :fields="telephoneOperatorsFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedTelephoneOperators"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      telephoneOperatorsFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'balance', label: this.$i18n.t('Balance'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedTelephoneOperators: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedTelephoneOperators = {
        account: '',
        act_adress: '',
        bank_id: 0,
        bookeeper: '',
        client_prefix: '',
        contract_number: '',
        contract_place: '',
        headman: '',
        inn: '',
        jur_adress: '',
        kpp: '',
        number_format: '',
        service_place: '',
        short_bookeeper: '',
        short_headman: '',
        short_name: '',
        tax_rate: 0,
        type: 1,
        name: '',
        id: 0
      }
      this.$root.$emit('bv::show::modal', 'modalTelephoneOperators', '#btnShow')
    },
    editItem (item) {
      this.selectedTelephoneOperators = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalTelephoneOperators', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Telephone operators"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_TELEPHONE_OPERATORS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_TELEPHONE_OPERATORS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    telephoneOperators () {
      let telephoneOperators = []
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/TELEPHONE_OPERATORS']))
      for (let el of copy) {
        if (el.type === 1) {
          telephoneOperators.push(el)
        }
      }
      return telephoneOperators
    }
  },
  mounted () {
    this.$store.dispatch('ReferenceBooks/GET_CURRENCIES')
    this.$store.dispatch('Settings/GET_TELEPHONE_OPERATORS')
    this.$store.dispatch('Tariffing/GET_TEL_ZONES')
    this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': 20, 'offset': 0, 'filter': ''})
    this.$store.dispatch('Tariffing/GET_TIME_RANGE')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/telephony/telephoneOperators/main.vue